/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduledOrdersConfigCreateResponse } from '../../models/scheduled-orders-config-create-response';

export interface GetScheduledOrdersConfiguration$Params {
  storeId: string;
  'Active-Tenant-Identifier': string;
}

export function getScheduledOrdersConfiguration(http: HttpClient, rootUrl: string, params: GetScheduledOrdersConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduledOrdersConfigCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, getScheduledOrdersConfiguration.PATH, 'get');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduledOrdersConfigCreateResponse>;
    })
  );
}

getScheduledOrdersConfiguration.PATH = '/stores/{storeId}/scheduled-orders';
